import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { LDL } from '../../../lowerDisplayLine/styles';

export const styles = StyleSheet.create({
  logo: {
    height: '100%',
    width: LDL.logoWidth,
  },
  logoTime: {
    flexDirection: 'row',
    height: LDL.height,
    width: LDL.timeLogoWidth,
  },
  temperatureTimeWrapper: {
    position: 'absolute',
  },
  timeBackground: {
    alignItems: 'center',
    backgroundColor: Theme.withOpacity(Theme.white, 0.1),
    height: '100%',
    justifyContent: 'center',
    width: LDL.timeWidth,
  },
});
